/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliGroupDto } from '../../models/amoxcalli-group-dto';

export interface ApiGroupsGet$Json$Params {
  cycleId?: string;
  teacherId?: string;
  includeArchived?: boolean;
}

export function apiGroupsGet$Json(http: HttpClient, rootUrl: string, params?: ApiGroupsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliGroupDto>>> {
  const rb = new RequestBuilder(rootUrl, apiGroupsGet$Json.PATH, 'get');
  if (params) {
    rb.query('cycleId', params.cycleId, {});
    rb.query('teacherId', params.teacherId, {});
    rb.query('includeArchived', params.includeArchived, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliGroupDto>>;
    })
  );
}

apiGroupsGet$Json.PATH = '/api/groups';
